"use strict";

var _interopRequireDefault = require("/Users/ikode/Projects/vota/vota-monorepo/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCodeImg = getCodeImg;
exports.getInfo = getInfo;
exports.login = login;
exports.logout = logout;
var _request = _interopRequireDefault(require("@/utils/request"));
function login(username, password, code, uuid) {
  return (0, _request.default)({
    url: 'auth/login',
    method: 'post',
    data: {
      username: username,
      password: password,
      code: code,
      uuid: uuid
    }
  });
}
function getInfo() {
  return (0, _request.default)({
    url: 'auth/info',
    method: 'get'
  });
}
function getCodeImg() {
  return (0, _request.default)({
    url: 'auth/code',
    method: 'get'
  });
}
function logout() {
  return (0, _request.default)({
    url: 'auth/logout',
    method: 'delete'
  });
}